/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_Add_CodeInputs */

const en_friends_add_code = /** @type {(inputs: Friends_Add_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A friend’s code`)
};

const de_friends_add_code = /** @type {(inputs: Friends_Add_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code eines Freundes`)
};

/**
* | output |
* | --- |
* | "A friend’s code" |
*
* @param {Friends_Add_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_add_code = /** @type {((inputs?: Friends_Add_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_Add_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_add_code(inputs)
	return en_friends_add_code(inputs)
});